<template>
  <div>
    <div v-if="$apollo.loading">
      <spinner />
    </div>
    <v-layout v-else justify-center>
      <div class="registration-success-page">
        <img class="info-image" src="../../../public/assets/sad_cloud.svg" alt="sad_cloud">
        <span class="my-page-title">{{ $t('paymentUnsuccessful', 'Payment unsucessful!') }}</span>
        <span class="description">
          {{ $t('paymentUnsuccessfulDescription') }}
        </span>
        <button
          class="main-button v-btn v-btn--depressed v-btn--round theme--light primary"
          @click="gotBackToPayment"
        >
          <span>{{ $t('paymentUnsuccessfulActionButton', 'Back to payment') }}</span>
        </button>
        <button class="button-no-background" @click="goToPublicPage">
          {{ $t('cancel', 'Cancel') }}
        </button>
      </div>
    </v-layout>
  </div>
</template>

<script>
import ApplicationHeader from '../shared/application-header.vue'
import ApplicationFooter from '../shared/application-footer.vue'
import { GET_ORDER_INFO_BY_UUID } from '../../graphql/order.graphql'

export default {
  name: 'failed-payment',
  props: {
    orderUUID: {
      type: String,
      default: null,
    },
    event: {
      type: Object,
      deafult: () => {},
    },
  },
  data() {
    return {
      slug: undefined,
    }
  },
  apollo: {
    getOrderInfoByUUID: {
      query: GET_ORDER_INFO_BY_UUID,
      variables() {
        return {
          uuid: this.orderUUID,
        }
      },
      async result({ loading, data: { getOrderInfoByUUID } }) {
        if (!loading) {
          this.slug = getOrderInfoByUUID.event.slug
        }
      },
    },
  },
  methods: {
    goToPublicPage() {
      this.$router.push({
        name: 'register',
        params: { eventSlug: this.slug },
      })
    },
    gotBackToPayment() {
      this.goTo(this.routes.shared.register, {
        eventSlug: this.slug,
        orderNumber: this.orderUUID,
        status: 'FAILED',
      })
    },
  },
}
</script>

<style scoped>
.button-no-background {
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: -0.015em;
  text-transform: uppercase;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
  padding: 8px 16px;
}

.mt-50 {
  margin-top: 50px;
}

.my-page-title {
  font-family: Raleway, serif;
  font-style: normal;
  font-weight: bold;
  text-align: center;
  font-size: 38px;
  line-height: 45px;
  color: #ff4c00;
  margin-bottom: 24px;
  margin-top: 60px;
}

.registration-success-page {
  max-width: 640px !important;
  align-items: center;
  margin: 120px 20px 0 20px;
  display: flex;
  flex-direction: column;
}

.info-image {
  width: 100%;
  height: calc(100vh - 544px);
}

.description {
  font-family: Source Sans Pro, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 23px;
  text-align: center;
  color: #333333;
}

.mt-220 {
  margin-top: 220px;
}

.main-button {
  font-size: 16px;
  height: 36px;
  font-family: Raleway, sans-serif;
  font-weight: bold;
  line-height: 1.5;
}
</style>
